import _pick from 'lodash/pick';

import {
  DEFAULT_BRANDING_ID,
  DEFAULT_ORGANIZATION_TYPE_ID,
  DEFAULT_TIMEZONE,
  DEFAULT_COUNTRY,
  DEFAULT_CURRENCY,
  DEFAULT_RATE_PROVIDER_ID,
  DEFAULT_UNIT_TYPE
} from '../constants/constants';

const FIELDS = [
  'id',
  'name',
  'rowVersion',
  'orgId',
  'externalId',
  'timeZoneId',
  'config',
  'superUserFirstName',
  'superUserLastName',
  'superUserLoginEmail'
];

const Organization = () => {
  return {
    id: null,
    name: '',
    externalId: null,
    timeZoneId: DEFAULT_TIMEZONE,
    config: {
      autoGeneratedBolNumbers: true,
      autoTenderEnabled: false,
      defaultUnitType: DEFAULT_UNIT_TYPE,
      defaultDockOpenTime: 28800,
      defaultDockCloseTime: 57600,
      defaultLocationId: null,
      brandingId: DEFAULT_BRANDING_ID,
      defaultLeadTimeWindowMinutes: 120,
      organizationTypeId: DEFAULT_ORGANIZATION_TYPE_ID,
      p44AccountGroup: null,
      defaultBolInstructions: null,
      rateProviders: [DEFAULT_RATE_PROVIDER_ID],
      requireGlCodeAssigned: false,
      requireProofOfDeliveryDocument: true,
      requireSignedBolDocument: true,
      defaultCountry: DEFAULT_COUNTRY,
      defaultCurrency: DEFAULT_CURRENCY,
      minimumLinearFeetForVltl: 12,
      minimumPalletCountForVltl: 6,
      minimumWeightInPoundsForVltl: 5000,
      varianceAllowedAmount: 10,
      varianceAllowedPercent: 5,
      acceptVarianceInYourFavor: true,
      automaticallyAcceptInvoiceWithinVarianceThreshold: true,
      orgUsersMustAcceptEula: true
    },
    superUserFirstName: '',
    superUserLastName: '',
    superUserLoginEmail: ''
  };
};

export const sanitize = values => {
  const {
    id,
    rowVersion,
    orgId,
    name,
    externalId,
    timeZoneId,
    config: {
      autoGeneratedBolNumbers,
      autoTenderEnabled,
      defaultUnitType,
      defaultDockOpenTime,
      defaultDockCloseTime,
      defaultLocationId,
      brandingId,
      defaultLeadTimeWindowMinutes,
      organizationTypeId,
      p44AccountGroup,
      defaultBolInstructions,
      rateProviders,
      requireGlCodeAssigned,
      requireProofOfDeliveryDocument,
      requireSignedBolDocument,
      defaultCountry,
      defaultCurrency,
      minimumLinearFeetForVltl,
      minimumPalletCountForVltl,
      minimumWeightInPoundsForVltl,
      varianceAllowedAmount,
      varianceAllowedPercent,
      acceptVarianceInYourFavor,
      automaticallyAcceptInvoiceWithinVarianceThreshold,
      orgUsersMustAcceptEula,
      defaultBillingTerms: {
        addressInfo: { address1, address2, city, country, postalCode, state },
        companyName,
        contactInfo: { email, firstName, lastName, phone },
        defaultPaymentTerms
      }
    },
    superUserFirstName,
    superUserLastName,
    superUserLoginEmail,
    ...initialValues
  } = _pick(values, FIELDS);

  if (id) {
    return {
      orgId,
      name,
      externalId,
      timeZoneId,
      config: {
        autoGeneratedBolNumbers,
        autoTenderEnabled,
        defaultUnitType,
        defaultDockOpenTime,
        defaultDockCloseTime,
        defaultLocationId,
        brandingId,
        defaultLeadTimeWindowMinutes,
        organizationTypeId,
        p44AccountGroup,
        defaultBolInstructions,
        rateProviders,
        requireGlCodeAssigned,
        requireProofOfDeliveryDocument,
        requireSignedBolDocument,
        defaultCountry,
        defaultCurrency,
        minimumLinearFeetForVltl,
        minimumPalletCountForVltl,
        minimumWeightInPoundsForVltl,
        varianceAllowedAmount,
        varianceAllowedPercent,
        acceptVarianceInYourFavor,
        automaticallyAcceptInvoiceWithinVarianceThreshold,
        orgUsersMustAcceptEula,
        defaultBillingTerms: {
          addressInfo: {
            address1,
            address2,
            city,
            country,
            postalCode,
            state
          },
          companyName,
          contactInfo: {
            email,
            firstName,
            lastName,
            phone
          },
          defaultPaymentTerms
        }
      },
      rowVersion
    };
  }
  return {
    ...initialValues,
    name,
    externalId,
    timeZoneId,
    config: {
      autoGeneratedBolNumbers,
      autoTenderEnabled,
      defaultUnitType,
      defaultDockOpenTime,
      defaultDockCloseTime,
      defaultLocationId,
      brandingId,
      defaultLeadTimeWindowMinutes,
      organizationTypeId,
      p44AccountGroup,
      defaultBolInstructions,
      rateProviders,
      requireGlCodeAssigned,
      requireProofOfDeliveryDocument,
      requireSignedBolDocument,
      defaultCountry,
      defaultCurrency,
      minimumLinearFeetForVltl,
      minimumPalletCountForVltl,
      minimumWeightInPoundsForVltl,
      varianceAllowedAmount,
      varianceAllowedPercent,
      acceptVarianceInYourFavor,
      automaticallyAcceptInvoiceWithinVarianceThreshold,
      defaultBillingTerms: {
        addressInfo: {
          address1,
          address2,
          city,
          country,
          postalCode,
          state
        },
        companyName,
        contactInfo: {
          email,
          firstName,
          lastName,
          phone
        },
        defaultPaymentTerms
      }
    },
    superUserFirstName,
    superUserLastName,
    superUserLoginEmail
  };
};

export default Organization;
